module.exports = __webpack_public_path__ + "8a3f7e5746121293a7c12d55dd23cf3e.svg";